export default __webpack_public_path__ + "static/media/badge_education.15f0f95b.svg";